import { render } from "./VmsSidebarCamerasTab.vue?vue&type=template&id=352c1f9b&ts=true"
import script from "./VmsSidebarCamerasTab.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTab.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTab.vue?vue&type=style&index=0&id=352c1f9b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__